import { render, staticRenderFns } from "./DataTablePlan.vue?vue&type=template&id=5101a8d2"
import script from "./DataTablePlan.vue?vue&type=script&lang=js"
export * from "./DataTablePlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports